<template>
  <TextCell
    :id="id"
    :editable="editable"
    :label="description"
    :error="error"
    @change="(val) => $emit('change', val)"
    @contextmenu.stop="(e) => $emit('contextmenu', e)"
    @keydown.native="checkKey"
  >
    <div slot="pre" class="cell-id_container" :class="{ 'cell-id_in-group': inGroup }">
      <div class="cell-id_index">{{ index }}</div>
      <Button class="cell-id_actions" type="func" icon="more-horizontal" @click="openOptions" />
    </div>
    <template #after>
      <Button type="func" icon="maximize" @click="$emit('open-card')" />
    </template>
  </TextCell>
</template>

<script>
  import TextCell from '@/components/common/TextCell';
  import NAVIGATION_BUTTONS_KEY_CODES from '@/utils/constants/navigation-buttons';
  import Button from '@/components/ui-v2/Button';
  import { mapActions } from 'vuex';

  export default {
    components: {
      TextCell,
      Button,
    },
    props: {
      id: {
        type: String,
      },
      description: {
        type: String,
        default: '',
      },
      error: {
        type: String,
        default: '',
      },
      rowId: {
        type: [Number, String],
        default: null,
      },

      /**
       * If we're not in the last version of the project - all fields should be disabled
       */
      editable: {
        type: Boolean,
        default: false,
      },
      inGroup: {
        type: Boolean,
        default: false,
      },
      index: {
        type: [Number, String],
        default: null,
      },
    },
    data() {
      return {
        open: false,
      };
    },
    methods: {
      ...mapActions('modal', ['openModal']),
      checkKey(e) {
        if (NAVIGATION_BUTTONS_KEY_CODES.includes(e.keyCode)) {
          this.$emit('change-focused-cell', { e, value: this.description, id: this.id });
        }
      },
      openOptions(e) {
        this.$emit('options', e);
      },
    },
  };
</script>
<style scoped lang="scss">
  .cell-id_in-group {
    margin-left: 28px;
  }
</style>
